import * as types from '../mutation-types'
import req from '@/lib/authRequest'

const state = {
  notices: [],
  allNotices: []
}

const getters = {
  activeNotices: state => {
    return state.notices
  }
}

const mutations = {
  [types.SET_NOTICES] (state, notices) {
    state.notices = notices
  },
  [types.SET_ALL_NOTICES] (state, allNotices) {
    state.allNotices = allNotices
  },
  [types.REMOVE_NOTICE] (state, noticeId) {
    state.notices = state.notices.filter((notice) => {
      return notice.id !== noticeId
    })
  }
}

const actions = {
  /*
    Get the list of notices for the logged in user
   */
  getNotices ({ commit }) {
    return new Promise((resolve, reject) => {
      req.get({
        url: '/notices',
        success (result) {
          commit(types.SET_NOTICES, result)
          resolve()
        },
        error (result) {
          reject(result)
        }
      })
    })
  },
  /*
    Get a list of all of the notices (for admins)
   */
  getAllNotices ({ commit }) {
    return new Promise((resolve, reject) => {
      req.get({
        url: '/notices/all',
        success (result) {
          commit(types.SET_ALL_NOTICES, result)
          resolve()
        },
        error (result) {
          reject(result)
        }
      })
    })
  },
  /*
    Let an admin create a new global notice
   */
  createNotice ({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      req.post({
        url: '/notices',
        data: data,
        success (result) {
          dispatch('getAllNotices')
          dispatch('getNotices')
          resolve()
        },
        error (result) {
          reject(result)
        }
      })
    })
  },
  /*
    Let an admin delete a global notice
   */
  deleteNotice ({ dispatch }, noticeId) {
    return new Promise((resolve, reject) => {
      req.delete({
        url: '/notices/' + noticeId,
        success (result) {
          dispatch('getAllNotices')
          dispatch('getNotices')
          resolve()
        },
        error (result) {
          reject(result)
        }
      })
    })
  },
  /*
    Lets a user acknowledge a notice so that it is not displayed again
   */
  acknowledgeNotice ({ dispatch }, noticeId) {
    return new Promise((resolve, reject) => {
      req.post({
        url: '/notices/' + noticeId + '/ack',
        success (result) {
          dispatch('getNotices')
          resolve()
        },
        error (result) {
          reject(result)
        }
      })
    })
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/notices.js